import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {APP} from "../../../core/app/consts";
import {MATCH_WIDGET} from "../match-widget.consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class MatchWidgetDisplayEvent extends BaseAnalyticsEvent {
  gameId: Number;
  competitionId: Number;
  status: String;
  sportTypeId: Number;
  isMatchTracker: Boolean;
  isRelatedGame: Boolean;
  isTopPerformers: Number;
  placement: APP.GOOGLE_ANALYTICS.SOURCES;
  pageType: MATCH_WIDGET.PAGE_TYPE;

  constructor(params) {
    super('', 'display', 'match-details');

    this.gameId = params.gameId;
    this.competitionId = params.competitionId;
    this.status = params.status;
    this.sportTypeId = params.sportTypeId;
    this.isMatchTracker = params.isMatchTracker;
    this.isRelatedGame = params.isRelatedGame;
    this.isTopPerformers = params.isTopPerformers;
    this.placement = params.placement;
    this.pageType = params.pageType;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.competitionId = this.competitionId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.sportTypeId = this.sportTypeId;
    properties.isMatchTracker = this.isMatchTracker;
    properties.isRelatedGame = this.isRelatedGame;
    properties.isTopPerformers = this.isTopPerformers;
    properties.pageType = this.pageType;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();

    return new GoogleAnalyticsEventModel(eventName, {
      properties: {
        placement: this.placement,
        pageType: this.pageType,
      }
    })
  }
}
